import {
    Clock,
    MapPin,
    Trash2
} from "lucide-react";

const SPORT_COLORS = {
    badminton: "#00ff88",
    cricket: "#00d4ff",
};

function CartItem({
    item,
    onRemove
}) {

    return (

        <div style={styles.card}>

            <div style={styles.left}>

                <div style={styles.topRow}>

                    <h3 style={styles.title}>
                        {item.courtName}
                    </h3>

                    <span
                        style={{
                            ...styles.sport,
                            color:
                                SPORT_COLORS[item.sport],
                            borderColor:
                                SPORT_COLORS[item.sport],
                        }}
                    >
                        {item.sport}
                    </span>

                </div>

                <div style={styles.meta}>

                    <div style={styles.metaItem}>
                        <Clock size={15} />
                        {item.timeSlot}
                    </div>

                    <div style={styles.metaItem}>
                        <MapPin size={15} />
                        {item.location}
                    </div>

                </div>

            </div>

            <div style={styles.right}>

                <div style={styles.price}>
                    ${item.price}
                </div>

                <button
                    style={styles.remove}
                    onClick={() =>
                        onRemove(item.id)
                    }
                >
                    <Trash2 size={18} />
                </button>

            </div>

        </div>
    );
}

const styles = {

    card: {

        display: "flex",

        justifyContent:
            "space-between",

        alignItems: "center",

        padding: "22px",

        borderRadius: "20px",

        background:
            "rgba(255,255,255,0.04)",

        border:
            "1px solid rgba(0,255,150,0.12)",

        transition: "0.25s ease",
    },

    left: {
        flex: 1,
    },

    topRow: {

        display: "flex",

        alignItems: "center",

        gap: "12px",

        marginBottom: "14px",
    },

    title: {
        margin: 0,
        color: "#fff",
        fontSize: "18px",
        fontWeight: "700",
    },

    sport: {

        padding: "6px 12px",

        borderRadius: "999px",

        border: "1px solid",

        fontSize: "12px",

        textTransform: "capitalize",

        background:
            "rgba(255,255,255,0.04)",
    },

    meta: {
        display: "flex",
        gap: "18px",
        flexWrap: "wrap",
    },

    metaItem: {

        display: "flex",

        alignItems: "center",

        gap: "6px",

        color: "#d1d5db",

        fontSize: "14px",
    },

    right: {
        textAlign: "right",
    },

    price: {

        color: "#00ff88",

        fontSize: "24px",

        fontWeight: "800",

        marginBottom: "12px",
    },

    remove: {

        background:
            "rgba(255,255,255,0.04)",

        border:
            "1px solid rgba(255,0,80,0.2)",

        color: "#ff5c7a",

        width: "40px",

        height: "40px",

        borderRadius: "12px",

        cursor: "pointer",
    },
};

export default CartItem;